export const FI_UPGRADE_CTA_TEXT =
  'This applicant has Financial Insights — upgrade your plan to view.'
